module.exports = __webpack_public_path__ + "img/usa-diabetes-mellitus-male.27f01fe4.png";